import z from 'zod';
import { scopedEntity, alarmRef } from '../common';
import { assetRefWithSubset } from './asset';
import { namedCustomerRef } from './customer';
export const alarmHelper = z.object({
    ...scopedEntity.shape,
    customer: namedCustomerRef,
    asset: assetRefWithSubset.nullable(),
    alarm: alarmRef,
    confirmedHelping: z.boolean().nullable(),
});
